import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Eyebrow } from './Eyebrow';
function Stars({
  size
}: {
  size: string;
}) {
  return <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-339" data-mp="3itve3oyspzva">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className={`${size} fill-amber text-amber`} aria-hidden="true" data-id="element-340" data-mp="3mufc0ur717ih" data-mpi={index} />)}
    </div>;
}
export function TestimonialWall() {
  const [featured, ...supporting] = testimonials;
  return <section aria-labelledby="reviews-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-341" data-mp="3dvbqzl8gui1c">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-342" data-mp="2zvsvpt0r716g">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-343" data-mp="33wcu0zx2cau6">
          <div data-id="element-344" data-mp="33y612gbl8x2p">
            <Eyebrow data-id="element-345" data-mp="y3nxjzsnv7na">Trusted by jazz educators worldwide</Eyebrow>
            <h2 id="reviews-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-346" data-mp="y1a41vdmq3hu">
              What educators <span className="text-amber" data-id="element-347" data-mp="1wlqw8jw3xxc7">are saying</span>
            </h2>
          </div>
          <p className="flex items-center gap-2 text-sm text-cream-muted" data-id="element-348" data-mp="1rmxjitonaad3">
            <StarIcon className="h-4 w-4 fill-amber text-amber" aria-hidden="true" data-id="element-349" data-mp="26deim6dt4o6t" />
            <span className="font-semibold text-cream" data-id="element-350" data-mp="21ds7q3lgbk16">4.9/5</span> &middot; 2,500+ educators
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:mt-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-6" data-id="element-351" data-mp="1dno43w89jka6">
          <figure className="flex flex-col rounded-2xl border border-amber/40 bg-night-800 p-6 sm:p-10" data-id="element-352" data-mp="18pw7iowob9zn">
            <Stars size="h-4 w-4" data-id="element-353" data-mp="1nnev3nxm7h5i" />
            <blockquote className="mt-6 font-serif text-2xl italic leading-snug text-cream sm:mt-7 sm:text-3xl" data-id="element-354" data-mp="1nkaka7pn9n5v">
              &ldquo;{featured.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-9" data-id="element-355" data-mp="2yzz974mgkw9b">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber text-xs font-bold tracking-wider text-night" data-id="element-356" data-mp="2u1e7t1vh06ja">
                {featured.initials}
              </span>
              <span className="text-sm text-cream-muted" data-id="element-357" data-mp="363fj5leb9rph">
                <span className="block font-semibold text-cream" data-id="element-358" data-mp="3b437fzb5nug0">{featured.name}</span>
                {featured.role} &middot; {featured.location}
              </span>
            </figcaption>
          </figure>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-359" data-mp="2ifo6uhsrteo7">
            {supporting.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-night-600 bg-night-800 p-6" data-id="element-360" data-mp="2ndg0bg92d8ui">
                <Stars size="h-3 w-3" data-id="element-361" data-mp="2x4266iqzal00" />
                <blockquote className="mt-4 text-sm leading-relaxed text-cream-soft" data-id="element-362" data-mp="2x53u3nt3f1z5">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5 text-xs text-cream-muted" data-id="element-363" data-mp="24nrgojanxeug">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-night-600 text-[10px] font-bold text-amber" data-id="element-364" data-mp="lsd8l0qy37wc">
                    {item.initials}
                  </span>
                  <span data-id="element-365" data-mp="crowwcp0xjmm">
                    <span className="font-semibold text-cream" data-id="element-366" data-mp="cqvwrukklsdg">{item.name}</span> &middot; {item.role}{' '}
                    &middot; {item.location}
                  </span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}